const STATUS_TITLE = {
  SUCCESS: '成功',
  ERROR: 'おっとっと！'
}

const STATUS_MESSAGE = {
  CREATED: '正常に作成されました！',
  UPDATED: '正常に更新されました！',
  DELETED: '正常に削除されました！',
  FILE_UPDATED: 'ファイルが正常に更新されました！',
  FILE_DELETED: 'ファイルが正常に削除されました！',
  FOLDER_UPDATED: 'フォルダが正常に更新されました！',
  FOLDER_DELETED: 'フォルダが正常に削除されました！'
}

export {
  STATUS_TITLE,
  STATUS_MESSAGE
}



// WEBPACK FOOTER //
// ./src/utils/notificationMessage.js